// if (process.env.NODE_ENV !== "production") {
//   require("dotenv").config();
// }

export const API_URL = process.env.REACT_APP_API_URL || "";
export const AUTH0_DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN || "";
export const AUTH0_CLIENT_ID = process.env.REACT_APP_AUTH0_CLIENT_ID || "";
export const AUTH0_AUDIENCE = process.env.REACT_APP_AUTH0_AUDIENCE || "";
